import { useMemo } from 'react'

import { documentCategoryOptions } from '@/features/admin/documents/helpers'
import { useReselector } from '@/utils/sharedHooks'
import { getUserDocumentCategoriesById } from '@/features/admin/user-document-categories/userDocumentCategories.selectors'
import { UploadDocumentType } from '@/constants/businessConstants'
import { Select } from '@/ui'

interface IDocumentCategorySelectProps {
  userDocumentCategoryId: number | null | undefined
  setUserDocumentCategoryId: (id: number | null | undefined) => void
  documentCategoryType: UploadDocumentType
}

export const DocumentCategorySelect = ({
  userDocumentCategoryId,
  setUserDocumentCategoryId,
  documentCategoryType,
}: IDocumentCategorySelectProps) => {
  const documentCategories = useReselector(getUserDocumentCategoriesById)
  const filteredDocumentCategories = useMemo(
    () =>
      documentCategoryOptions(documentCategories, documentCategoryType, false),
    [documentCategories, documentCategoryType]
  )
  const selectOptions = useMemo(
    () =>
      filteredDocumentCategories.map((category) => ({
        key: category.value,
        value: String(category.value),
        text: String(category.text),
      })),
    [filteredDocumentCategories]
  )

  const handleValueChange = (value: string | undefined) => {
    if (value === undefined) {
      setUserDocumentCategoryId(null)
    } else {
      setUserDocumentCategoryId(Number(value))
    }
  }

  return (
    <Select
      value={
        userDocumentCategoryId ? String(userDocumentCategoryId) : undefined
      }
      onValueChange={handleValueChange}
      placeholder="Select document category"
      options={selectOptions}
      clearable
    />
  )
}
